/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Flex } from '@tishman/components';
import { Article } from '@hzdg/sectioning';
import React from 'react';

import { CardDetail, CardDetailProps } from '../common/CardDetail';

export type TicketCardProps = Pick<CardDetailProps, 'ticket' | 'category'>;

export function TicketCard({
  category,
  ticket,
}: TicketCardProps): React.JSX.Element {
  return (
    <Flex
      as={Article}
      data-ticket-card={category.title}
      sx={{
        flexDirection: 'column',
        justifyContent: 'flex-start',
        minWidth: '215px',
      }}
    >
      <CardDetail category={category} ticket={ticket} />
    </Flex>
  );
}
